/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Cv_Consent_RequiredInputs */

const en_validation_cv_consent_required = /** @type {(inputs: Validation_Cv_Consent_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please consent to the processing of your resume to continue.`)
};

const de_validation_cv_consent_required = /** @type {(inputs: Validation_Cv_Consent_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte stimmen Sie der Verarbeitung Ihres Lebenslaufs zu, um fortzufahren.`)
};

/**
* | output |
* | --- |
* | "Please consent to the processing of your resume to continue." |
*
* @param {Validation_Cv_Consent_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const validation_cv_consent_required = /** @type {((inputs?: Validation_Cv_Consent_RequiredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Cv_Consent_RequiredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_validation_cv_consent_required(inputs)
	return en_validation_cv_consent_required(inputs)
});